import React, { useEffect, useRef, useState } from "react";
import {
  Field,
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import {
  Avatar,
  GridLayout,
  GridLayoutItem,
} from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import {
  GridCellProps,
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  Grid as KendoGrid,
  GridColumn as Column,
  GridPageChangeEvent,
} from "@progress/kendo-react-grid";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import {
  HeaderThElement,
  PagerTargetEvent,
} from "@progress/kendo-react-data-tools";

import { useLocation, useNavigate } from "react-router-dom";

import ShadowCard from "../../components/common/ShadowCard";
import FormTextField from "../../components/formFields/FormTextField";
import {
  requiredValidator,
  skipValidator,
} from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { LoadingPanel } from "../../components/layout/Loading";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import FormDatePicker from "../../components/formFields/FormDateField";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import AlertBox from "../../components/common/AlertBox";

import {
  createOrder,
  getOrderById,
  getRecentOderderDataByItemID,
  updateOrder,
} from "./services/order.services";
import { findAllActiveParty } from "../party/services/party.services";
import {
  findAllActiveItem,
  getImageById,
} from "../item/services/item.services";
import { findAllActivePriority } from "../priority/services/priority.services";
import { findAllActivePurity } from "../purity/services/purity.services";

import { clearOrderDetail } from "./orderSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

import { RootState } from "../../app/store";

import moment from "moment";
import { findIndex } from "lodash";
import Slider from "react-slick";

import ProcessDetailArray from "./ProcessDetailArray";

import { FaEye, FaRegEye } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { MdOutlineImageNotSupported } from "react-icons/md";
import { clearImageList } from "../item/itemSlice";
import { findAllActiveKarigar } from "../karigar/services/karigar.services";
import { findAllActiveProcess } from "../process/services/process.services";
import { IPurity } from "../purity/purityModel";
import OrderImageArray from "./OrderImageArray";
import FormTextArea from "../../components/formFields/FormTextArea";
import {
  closePriorityDrawerOpen,
  openPriorityDrawerOpen,
} from "../priority/prioritySlice";
import {
  closePurityDrawerOpen,
  openPurityDrawerOpen,
} from "../purity/puritySlice";
import { CustomAppDrawer } from "../../components/muidrawer/Drawer";
import CreatePriority from "../priority/CreatePriority";
import CreatePurity from "../purity/CreatePurity";
// import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";

interface IChangeWatcher {
  formRenderProps: FormRenderProps;
}
const OrderChangeWatcher: React.FC<IChangeWatcher> = ({ formRenderProps }) => {
  const dispatch = useAppDispatch();
  const itemList = useAppSelector((state) => state.item.ItemList);
  const processdetails = formRenderProps.valueGetter("processdetails");
  const item_ID = formRenderProps.valueGetter("item_id");
  const isItemRef = useRef(true);

  const handleGetRecentDetail = async () => {
    const res = await dispatch(getRecentOderderDataByItemID(item_ID));
    if (res.meta.requestStatus === "fulfilled" && res.payload) {
      dispatch(openDialog("fillrecentorderdetaildialog"));
    } else {
      dispatch(closeDialog());
    }
  };

  useEffect(() => {
    if (!isItemRef.current) {
      const ItemIndex = findIndex(itemList, { id: item_ID });
      if (ItemIndex > -1) {
        const ItemData = itemList[ItemIndex];
        const remarksValue = ItemData.remarks;
        dispatch(getImageById(ItemData?.id));
        processdetails.map((item: any, index: number) =>
          formRenderProps.onChange(`processdetails.${index}.image_id`, {
            value: null,
          }),
        );
        formRenderProps.onChange("remark", {
          value: remarksValue || " ",
        });
        formRenderProps.onChange("item_name", { value: ItemData.item_name });
        formRenderProps.onChange("item_code_id", { value: ItemData.item_id });
        formRenderProps.onChange("purity", { value: ItemData.purity_id });
        handleGetRecentDetail();
      } else {
        formRenderProps.onChange("remark", { value: "" });
        formRenderProps.onChange("item_code_id", { value: "" });
        formRenderProps.onChange("item_name", { value: "" });
        formRenderProps.onChange("purity", { value: null });
      }
    } else {
      isItemRef.current = false;
    }
  }, [item_ID]);

  /* Date Change Watcher */
  useEffect(() => {
    if (processdetails && processdetails.length > 0) {
      processdetails?.map((item: any, index: number) => {
        const receive_date = item?.given_date
          ? moment(item?.given_date)
              .add(+item?.duration_days || 0, "days")
              .toDate()
          : "";
        if (!item?.duration_days) {
          formRenderProps.onChange(`processdetails.${index}.duration_days`, {
            value: 0,
          });
        }
        formRenderProps.onChange(`processdetails.${index}.receive_date`, {
          value: receive_date || "",
        });
        formRenderProps.onChange(`processdetails.${index}.description`, {
          value: processdetails[index]?.description,
        });
      });
    }
  }, [
    processdetails?.map((item: any) => item?.duration_days).join("-"),
    processdetails?.map((item: any) => item?.given_date).join("-"),
    processdetails?.map((item: any) => item?.description).join("-"),
  ]);

  return null;
};

const CreateOrder: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [formKey, setFormKey] = useState(1);
  const OrderDetail = useAppSelector(
    (state: RootState) => state.order.OrderDetail,
  );

  const partyList = useAppSelector((state) => state.party.PartyList);
  const priorityList = useAppSelector((state) => state.priority.PriorityList);
  const PurityList = useAppSelector((state) => state.purity.PurityList);
  const formLoading = useAppSelector((state) => state.order.formLoading);
  const order_guid = location.state?.ID;
  const priorityDrawerOpen = useAppSelector(
    (state) => state.priority.priorityDrawerOpen,
  );
  const purityDrawerOpen = useAppSelector(
    (state) => state.purity.purityDrawerOpen,
  );
  const gridRef = useRef<any>(null);
  const today = new Date();
  const maxDate =
    new Date(today.getFullYear(), today.getMonth(), today.getDate()) || null;
  useEffect(() => {
    dispatch(findAllActiveParty());
    dispatch(findAllActivePriority());
    dispatch(findAllActivePurity());

    dispatch(findAllActiveKarigar());
    dispatch(findAllActiveProcess());
    if (order_guid) {
      dispatch(getOrderById(order_guid));
    }
    return () => {
      dispatch(closed());
      dispatch(clearOrderDetail());
      dispatch(clearImageList());
    };
  }, []);

  useEffect(() => {
    if (OrderDetail.item_id) {
      dispatch(getImageById(OrderDetail.item_id));
    }
  }, [OrderDetail.item_id]);

  const handleSubmit = async (values: any) => {
    const formData = {
      order_date: values.order_date
        ? moment(values.order_date).format("YYYY-MM-DD")
        : "",
      delivery_date: values.delivery_date
        ? moment(values.delivery_date).format("YYYY-MM-DD")
        : "",
      party_id: values.party_id ? values.party_id : null,
      item_id: values.item_id ? values.item_id : null,
      description: values.description,
      estimate_weight: values.estimate_weight ? +values.estimate_weight : 0,
      purity: values.purity ? +values.purity : null,
      priority_id: values.priority_id,
      item_code_id: values.item_code_id,
      color: values.color,
      estimate_amount: values.estimate_amount ? +values.estimate_amount : null,
      remark: values.remark,
      size: values.size,
      isactive: true,
      processdetails: values.processdetails
        ? values.processdetails.map((process_info: any) => {
            return {
              order_id: process_info.order_id,
              process_id: process_info.process_id
                ? +process_info.process_id
                : null,
              estimated_weight: process_info.estimated_weight
                ? +process_info.estimated_weight
                : 0,
              karigar_id: process_info.karigar_id
                ? +process_info.karigar_id
                : 0,
              given_date: process_info.given_date
                ? moment(process_info.given_date).format("YYYY-MM-DD")
                : "",
              duration_days: process_info.duration_days
                ? +process_info.duration_days
                : 0,
              description: process_info.description,
              receive_date: process_info.receive_date
                ? moment(process_info.receive_date).format("YYYY-MM-DD")
                : "",
              sizedetails: process_info.sizedetails
                ? process_info.sizedetails.map((size_details: any) => {
                    return {
                      title: size_details.title,
                      value: size_details.value,
                    };
                  })
                : [],
            };
          })
        : [],
    };
    if (order_guid) {
      const editPayload = {
        id: values.id,
        order_guid: order_guid,
        ...formData,
      };
      try {
        const response = await dispatch(updateOrder(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(clearOrderDetail());
          navigate("/order");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    } else {
      try {
        const response = await dispatch(createOrder(formData));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(clearOrderDetail());
          navigate("/order");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
    dispatch(clearOrderDetail());
    dispatch(clearImageList());
    navigate("/order");
  };

  const handleSelectProduct = () => {
    dispatch(openDialog("SelectProductDialog"));
    dispatch(findAllActiveItem());
  };

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [OrderDetail]);

  return (
    <>
      {formLoading && <LoadingPanel gridRef={gridRef} />}
      {priorityDrawerOpen && (
        <CustomAppDrawer
          open={priorityDrawerOpen}
          closeDrawerFunction={closePriorityDrawerOpen}
        >
          <CreatePriority />
        </CustomAppDrawer>
      )}
      {purityDrawerOpen && (
        <CustomAppDrawer
          open={purityDrawerOpen}
          closeDrawerFunction={closePurityDrawerOpen}
        >
          <CreatePurity />
        </CustomAppDrawer>
      )}
      <Form
        onSubmit={handleSubmit}
        key={formKey}
        initialValues={OrderDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <RecentDetailFillConfirm formRenderProps={formRenderProps} />
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h4>
                    {order_guid ? "Update Order" : "New Order"}
                  </Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem colSpan={3}>
                  {order_guid ? (
                    <Typography.h5>
                      Order No :{" "}
                      <span style={{ color: "green" }}>
                        {OrderDetail.order_no}
                      </span>
                    </Typography.h5>
                  ) : (
                    ""
                  )}
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="party_id"
                    label="Vepari Name"
                    placeholder="Select Vepari"
                    isAddNew={true}
                    isIndirect={true}
                    addNewLink="party/create"
                    component={FormSelectionField}
                    dispatcherFunction={findAllActiveParty}
                    validator={requiredValidator}
                    astrike={true}
                    options={partyList?.map((party: any) => {
                      return {
                        value: party.id,
                        label: `${party.party_nick_name || party.party_name}`,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="order_date"
                    label="Order Date"
                    placeholder="day/month/year"
                    format={"dd/MM/yyyy"}
                    max={maxDate}
                    component={FormDatePicker}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="delivery_date"
                    label="Delivery Date"
                    placeholder="day/month/year"
                    format={"dd/MM/yyyy"}
                    component={FormDatePicker}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "end",
                  }}
                >
                  <Button
                    type="button"
                    fillMode={"solid"}
                    themeColor={"primary"}
                    style={{ width: "fit-content", padding: "5px" }}
                    onClick={handleSelectProduct}
                  >
                    Select Product
                  </Button>
                  {formRenderProps.valueGetter("item_id") !== null && (
                    <Field
                      name="item_name"
                      label="Product Name"
                      placeholder="Product Name"
                      disabled={true}
                      wrapperStyle={{ width: "50%" }}
                      component={FormTextField}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  )}
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="item_code_id"
                    label="Product ID"
                    placeholder="Product ID"
                    disabled
                    component={FormTextField}
                    validator={!order_guid ? requiredValidator : skipValidator}
                    astrike={!order_guid ? true : false}
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "end",
                  }}
                >
                  {formRenderProps.valueGetter("item_id") !== null && (
                    <Button
                      type="button"
                      themeColor={"success"}
                      onClick={() => dispatch(openDialog("showProductImage"))}
                      fillMode={"solid"}
                    >
                      <FaEye style={{ fontSize: 20 }} /> View Product Images
                    </Button>
                  )}
                </GridLayoutItem>
                <ShowProductImageDialog />
                <GridLayoutItem
                  style={{ width: "100%", display: "flex", gap: 10 }}
                >
                  <Field
                    wrapperClassName="w-100"
                    name="priority_id"
                    label="Priority"
                    placeholder="Select Priority"
                    type="number"
                    isAddNew={true}
                    isIndirect={true}
                    isDrawerInDrawer={true}
                    drawerName="priorityForm"
                    CustomDrawerOpenFunction={openPriorityDrawerOpen}
                    component={FormSelectionField}
                    // validator={requiredValidator}
                    options={priorityList?.map((priority: any) => {
                      return {
                        value: priority.ID,
                        label: priority.priority,
                      };
                    })}
                  />
                  <Field
                    wrapperClassName="w-100"
                    name="estimate_weight"
                    label="Estimate Weight (gm)"
                    placeholder="0.000"
                    format="n3"
                    type="number"
                    component={FormNumericTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  style={{ width: "100%", display: "flex", gap: 10 }}
                >
                  <Field
                    wrapperClassName="w-100"
                    name="estimate_amount"
                    label="Estimate Rs"
                    placeholder="0"
                    type="number"
                    // min={0}
                    component={FormNumericTextField}
                    // validator={requiredValidator}
                  />
                  <Field
                    wrapperClassName="w-100"
                    name="size"
                    label="Size"
                    placeholder="0"
                    type="text"
                    format="n2"
                    component={FormTextField}
                    // validator={requiredValidator}
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  style={{ width: "100%", display: "flex", gap: 10 }}
                >
                  <Field
                    wrapperClassName="w-100"
                    name="purity"
                    label="Purity"
                    placeholder="Select Purity"
                    type="number"
                    isAddNew={true}
                    isIndirect={true}
                    isDrawerInDrawer={true}
                    drawerName="purityForm"
                    CustomDrawerOpenFunction={openPurityDrawerOpen}
                    component={FormSelectionField}
                    // validator={requiredValidator}
                    options={PurityList?.map((purity: IPurity) => {
                      return {
                        value: purity.ID,
                        label: `${purity.Carat}-${purity.purity}`,
                      };
                    })}
                  />
                  <Field
                    wrapperClassName="w-100"
                    name="color"
                    label="Color"
                    placeholder="i.e. Rose Gold"
                    component={FormTextField}
                    // validator={requiredValidator}
                  />
                </GridLayoutItem>
                <GridLayoutItem colSpan={2}>
                  <Field
                    name="remark"
                    label="Description"
                    placeholder="Description"
                    component={FormTextArea}
                    // validator={requiredValidator}
                  />
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
            <ShadowCard style={{ marginTop: 10 }}>
              <GridLayoutItem colSpan={6}>
                <Typography.h4>{"Process Details"}</Typography.h4>
              </GridLayoutItem>
              <FieldArray
                formRenderProps={formRenderProps}
                component={ProcessDetailArray}
                name="processdetails"
              />
            </ShadowCard>
            <FieldArray
              formRenderProps={formRenderProps}
              component={OrderImageArray}
              name="Images"
            />
            {/* <ShadowCard style={{ marginTop: 10 }}>
              <GridLayoutItem colSpan={3}>
                <Typography.h4>Size Details List</Typography.h4>
              </GridLayoutItem>
              <FieldArray
                formRenderProps={formRenderProps}
                component={SizeDetailArray}
                name="sizedetails"
              />
            </ShadowCard> */}
            <ShadowCard style={{ marginTop: 10 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem
                  colSpan={3}
                  style={{
                    textAlign: "end",
                    marginTop: "20px",
                    width: "100%",
                  }}
                >
                  <ButtonWithLoading
                    label={!order_guid ? "Create" : "Update"}
                    type="submit"
                    disabled={!formRenderProps.allowSubmit || formLoading}
                  />
                  <Button
                    type="button"
                    fillMode={"outline"}
                    themeColor={"primary"}
                    style={{ marginLeft: 4 }}
                    onClick={handleFormClose}
                  >
                    Cancel
                  </Button>
                </GridLayoutItem>
              </GridLayout>
              <OrderChangeWatcher formRenderProps={formRenderProps} />
              <SelectProductDialog formRenderProps={formRenderProps} />
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateOrder;

const ShowProductImageDialog: React.FC = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: false,
    // centerMode: true,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    centerPadding: "0px",
    centerMargin: "0px",
    draggable: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const loading = useAppSelector((state) => state.item.loading);
  const ImageList = useAppSelector((state) => state.item.ImageList);
  const gridRef = useRef<any>(null);

  const dispatch = useAppDispatch();

  const handleOpenImage = (url: string) => {
    if (url && typeof url === "string") {
      window.open(url);
    }
  };

  return (
    <>
      {dialogName === "showProductImage" && (
        <AppDialog>
          {loading ? (
            <div>
              <LoadingPanel gridRef={gridRef} />
            </div>
          ) : (
            <div style={{ width: "40vw", height: "50vh" }}>
              <GridLayout
                style={{
                  marginLeft: 10,
                }}
                gap={{ rows: 10, cols: 10 }}
              >
                <GridLayoutItem
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography.h4 style={{ margin: "0" }}>
                    {"Product Images"}
                  </Typography.h4>
                  <ImCross
                    style={{
                      color: "white",
                      background: "red",
                      borderRadius: "50%",
                      padding: "5px",
                      fontSize: "24px",
                    }}
                    onClick={() => dispatch(closeDialog())}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  {ImageList && ImageList?.length === 0 && (
                    <AlertBox alert="No Image Available!" />
                  )}
                </GridLayoutItem>
                <GridLayoutItem
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <div
                    className="slider-container product-view-images"
                    style={{ width: "30vw" }}
                  >
                    {ImageList && ImageList.length > 1 ? (
                      <Slider {...settings}>
                        {ImageList &&
                          ImageList.length > 0 &&
                          ImageList.map((image: any, index: number) => (
                            <div>
                              <div key={index} style={{ height: 300 }}>
                                <img
                                  src={image.image_name}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain",
                                  }}
                                  onClick={() =>
                                    handleOpenImage(image.image_name)
                                  }
                                />
                              </div>
                              {/* <Typography.h5 style={{ textAlign: "center" }}>
                                {image.title}
                              </Typography.h5> */}
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  gap: 5,
                                }}
                              >
                                <div
                                  style={{
                                    background: "#e8e8e8",
                                    padding: "5px 10px",
                                    borderRadius: "4px",
                                  }}
                                >
                                  <p
                                    style={{
                                      margin: "0 0 8px 0",
                                      fontSize: "14px",
                                      color: "#718096",
                                      fontWeight: 500,
                                    }}
                                  >
                                    Title
                                  </p>
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: "16px",
                                      color: "#2d3748",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {image.title || "N/A"}
                                  </p>
                                </div>
                                <div
                                  style={{
                                    background: "#e8e8e8",
                                    padding: "5px 10px",
                                    borderRadius: "4px",
                                  }}
                                >
                                  <p
                                    style={{
                                      margin: "0 0 8px 0",
                                      fontSize: "14px",
                                      color: "#718096",
                                      fontWeight: 500,
                                    }}
                                  >
                                    Process Name
                                  </p>
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: "16px",
                                      color: "#2d3748",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {image.process_name || "N/A"}
                                  </p>
                                </div>
                                <div
                                  style={{
                                    background: "#e8e8e8",
                                    padding: "5px 10px",
                                    borderRadius: "4px",
                                  }}
                                >
                                  <p
                                    style={{
                                      margin: "0 0 8px 0",
                                      fontSize: "14px",
                                      color: "#718096",
                                      fontWeight: 500,
                                    }}
                                  >
                                    Main Image
                                  </p>
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: "16px",
                                      color: "#2d3748",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {image.isreadyimage ? "YES" : "NO"}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ))}
                      </Slider>
                    ) : (
                      <>
                        {ImageList &&
                          ImageList.length > 0 &&
                          ImageList.map((image: any, index: number) => (
                            <div>
                              <div key={index} style={{ height: 300 }}>
                                <img
                                  src={image.image_name}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain",
                                  }}
                                  onClick={() =>
                                    handleOpenImage(image.image_name)
                                  }
                                />
                              </div>
                              {/* <Typography.h5 style={{ textAlign: "center" }}>
                                {image.title}
                              </Typography.h5> */}
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  gap: 5,
                                }}
                              >
                                <div
                                  style={{
                                    background: "#e8e8e8",
                                    padding: "5px 10px",
                                    borderRadius: "4px",
                                  }}
                                >
                                  <p
                                    style={{
                                      margin: "0 0 8px 0",
                                      fontSize: "14px",
                                      color: "#718096",
                                      fontWeight: 500,
                                    }}
                                  >
                                    Title
                                  </p>
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: "16px",
                                      color: "#2d3748",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {image.title || "N/A"}
                                  </p>
                                </div>
                                <div
                                  style={{
                                    background: "#e8e8e8",
                                    padding: "5px 10px",
                                    borderRadius: "4px",
                                  }}
                                >
                                  <p
                                    style={{
                                      margin: "0 0 8px 0",
                                      fontSize: "14px",
                                      color: "#718096",
                                      fontWeight: 500,
                                    }}
                                  >
                                    Process Name
                                  </p>
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: "16px",
                                      color: "#2d3748",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {image.process_name || "N/A"}
                                  </p>
                                </div>
                                <div
                                  style={{
                                    background: "#e8e8e8",
                                    padding: "5px 10px",
                                    borderRadius: "4px",
                                  }}
                                >
                                  <p
                                    style={{
                                      margin: "0 0 8px 0",
                                      fontSize: "14px",
                                      color: "#718096",
                                      fontWeight: 500,
                                    }}
                                  >
                                    Main Image
                                  </p>
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: "16px",
                                      color: "#2d3748",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {image.isreadyimage ? "YES" : "NO"}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ))}
                      </>
                    )}
                  </div>
                </GridLayoutItem>
              </GridLayout>
            </div>
          )}
        </AppDialog>
      )}
    </>
  );
};

const SelectProductDialog: React.FC<IChangeWatcher> = ({ formRenderProps }) => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog?.dialogName);
  const productList = useAppSelector((state) => state.item?.ItemList);

  const loading = useAppSelector((state) => state.item?.loading);
  const gridRef = useRef<any>(null);
  interface PageState {
    skip: number;
    take: number;
  }
  const initialDataState: PageState = { skip: 0, take: 10 };

  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();
  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All" ? productList.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  const MyImageCommandCell = (props: GridCellProps) => {
    const handlClickItem = (image: string) => {
      if (image && typeof image === "string") {
        window.open(image);
      }
    };
    if (props.dataItem?.image_name === null) {
      return (
        <td>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "50px",
            }}
          >
            <MdOutlineImageNotSupported style={{ fontSize: "30px" }} />
            {/* <p style={{ margin: 0, fontSize: "12px" }}>No Image!</p> */}
          </div>
        </td>
      );
    }
    return (
      <td className="action-td">
        <div
          style={{
            position: "relative",
          }}
        >
          {/* <img
            className="product-image"
            src={props.dataItem?.image_name}
            alt=""
            style={{
              height: "100%",
              width: "100%",
              objectFit: "cover",
              borderRadius: "5px",
            }}
          /> */}

          <Avatar
            style={{
              width: "50px",
              height: "50px",
              backgroundColor: props.dataItem?.image_name
                ? "transparent"
                : "#303F9F",
            }}
          >
            {props.dataItem?.image_name ? (
              <img
                src={props.dataItem?.image_name}
                alt={`No Image`}
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                }}
              />
            ) : (
              `No Image`
            )}
          </Avatar>
          <div className="image-view">
            <FaRegEye
              style={{
                color: "white",
                height: 24,
                width: 24,
                cursor: "pointer",
              }}
              onClick={() => handlClickItem(props.dataItem?.image_name)}
            />
          </div>
        </div>
      </td>
    );
  };

  const MyEditCommandCell = (props: any) => {
    const handleSelectProduct = (id: number) => {
      formRenderProps.onChange("item_id", { value: id });
      dispatch(closeDialog());
      setFilter(undefined);
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style }}
      >
        <Button
          type="button"
          fillMode="solid"
          themeColor={"primary"}
          size="small"
          title="Select Product"
          onClick={() => handleSelectProduct(props.dataItem?.id)}
        >
          Select
        </Button>
      </td>
    );
  };
  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 5 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  return (
    <>
      {dialogName === "SelectProductDialog" && (
        <AppDialog>
          <div style={{ width: "60vw", minHeight: "30vh", overflow: "hidden" }}>
            {loading ? (
              <LoadingPanel gridRef={gridRef} />
            ) : (
              <GridLayout gap={{ rows: 10, cols: 10 }}>
                <GridLayoutItem
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography.h4 style={{ margin: 0 }}>
                    {"Select Product"}
                  </Typography.h4>
                  <ImCross
                    style={{
                      color: "white",
                      background: "red",
                      borderRadius: "50%",
                      padding: "5px",
                      fontSize: "24px",
                    }}
                    onClick={() => dispatch(closeDialog())}
                  />
                </GridLayoutItem>
                <GridLayoutItem style={{ width: "60vw" }}>
                  {productList && productList.length ? (
                    <KendoGrid
                      scrollable="scrollable"
                      className="selection-dialog responsive-table"
                      style={{ maxHeight: "calc(100vh - 152px)" }}
                      filterable={true}
                      filter={filter}
                      data={
                        filter
                          ? filterBy(productList, filter).slice(
                              page.skip,
                              page.take + page.skip,
                            )
                          : productList.slice(page.skip, page.take + page.skip)
                      }
                      total={productList[0]?.itemcount || productList.length}
                      onFilterChange={handleFilterChange}
                      skip={page.skip}
                      take={page.take}
                      pageable={{
                        buttonCount: 5,
                        pageSizes: [5, 10, 15, "All"],
                        pageSizeValue: pageSizeValue,
                        type: "input",
                      }}
                      onPageChange={pageChange}
                      cells={{
                        headerCell: HeaderCustomCell,
                        data: MyDataCustomCell,
                      }}
                    >
                      <Column
                        field="image_name"
                        title="Image"
                        width={100}
                        cells={{ data: MyImageCommandCell }}
                        filterable={false}
                      />
                      <Column
                        field="item_name"
                        title="Product Name"
                        width={250}
                        cells={{
                          data: (props: any) => (
                            <td>
                              <div style={{ color: "green" }}>
                                <strong>{props.dataItem?.item_name}</strong>
                              </div>
                            </td>
                          ),
                        }}
                      />
                      {/* <Column
                        field="item_nick_name"
                        title="Product Short Name"
                        width={160}
                      /> */}
                      <Column
                        field="category_name"
                        title="Product Category"
                        width={250}
                      />
                      <Column
                        field="item_subcategory_name"
                        title="Product Sub Category"
                        width={200}
                      />
                      <Column
                        field="id"
                        title="Actions"
                        cells={{ data: MyEditCommandCell }}
                        width={100}
                        filterable={false}
                        locked={true}
                      />
                    </KendoGrid>
                  ) : (
                    <AlertBox />
                  )}
                </GridLayoutItem>
              </GridLayout>
            )}
          </div>
        </AppDialog>
      )}
    </>
  );
};

interface IRecentDetailFillConfirm {
  formRenderProps: FormRenderProps;
}

const RecentDetailFillConfirm: React.FC<IRecentDetailFillConfirm> = ({
  formRenderProps,
}) => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const RecentOrderDetail = useAppSelector(
    (state) => state.order.RecentOrderDetail,
  );

  const handleFillRecentOrder = () => {
    if (!RecentOrderDetail?.processdetails) return;

    const clonedData = JSON.parse(
      JSON.stringify(RecentOrderDetail.processdetails),
    );

    const mapData = clonedData?.map((item: any) => ({
      ...item,
      given_date: item.given_date ? moment(item.given_date).toDate() : "",
      receive_date: item.receive_date ? moment(item.receive_date).toDate() : "",
    }));

    formRenderProps.onChange("processdetails", {
      value: mapData,
    });

    formRenderProps.onChange("priority_id", {
      value: RecentOrderDetail?.priority_id || null,
    });

    formRenderProps.onChange("estimate_weight", {
      value: RecentOrderDetail?.estimate_weight || null,
    });

    formRenderProps.onChange("estimate_amount", {
      value: RecentOrderDetail?.estimate_amount || null,
    });
    formRenderProps.onChange("size", {
      value: RecentOrderDetail?.size || null,
    });
    formRenderProps.onChange("purity", {
      value: RecentOrderDetail?.purity || null,
    });
    formRenderProps.onChange("color", {
      value: RecentOrderDetail?.color || "",
    });
    formRenderProps.onChange("description", {
      value: RecentOrderDetail?.description || "",
    });

    dispatch(closeDialog());
  };
  return (
    <>
      {dialogName === "fillrecentorderdetaildialog" && (
        <AppDialog>
          <>
            <Typography.h5>{"Auto Fill Recent Order Details"}</Typography.h5>

            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to auto-fill the details from the most
                  recent order?
                </Typography.p>
              </GridLayoutItem>

              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                  marginTop: "10px",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode="solid"
                  themeColor="primary"
                  onClick={() => {
                    handleFillRecentOrder();
                  }}
                  type="button"
                >
                  Yes, Fill Details
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};
